import { createContext } from 'react';
import AmityStore from 'stores/AmityStore';
import BreedStore from 'stores/BreedStore';
import ChatMatchesStore from 'stores/ChatMatchesStore';
import MatchesStore from 'stores/MatchesStore';
import PagesStore from 'stores/PagesStore';
import SessionStore from 'stores/SessionStore';
import TestsStore from 'stores/TestsStore';
import TraitsStore from 'stores/TraitsStore';
import UserStore from 'stores/UserStore';

import CompleteSurveyStore from './CompleteSurveyStore';
import ErrorsStore from './ErrorsStore';
import HealthReportStore from './HealthReportStore';
import PopupsStore from './PopupsStore';

const errorStore = new ErrorsStore();
const testsStore = new TestsStore(errorStore);

export default createContext({
  amityStore: new AmityStore(),
  breedStore: new BreedStore(),
  matchesStore: new MatchesStore(),
  chatMatchesStore: new ChatMatchesStore(),
  sessionStore: new SessionStore(),
  testsStore,
  traitsStore: new TraitsStore(),
  userStore: new UserStore(),
  pagesStore: new PagesStore(),
  healthReportStore: new HealthReportStore(),
  completeSurveyStore: new CompleteSurveyStore(),
  popupsStore: new PopupsStore(),
  errorStore,
});
